import _ from 'lodash';
import update from 'immutability-helper';
import I18n from '../../config/i18n';
import monarch from '../common/clients/monarch';
import { handleAppError } from './app';

const initialState = {
  searchedTheatreName: '',
  theatres: [],
  busyLoadingDataFromServer: false,
  isLoading: false,
  hasMoreTheatres: false,
  offset: 0,
  ps: 10, // Items per page
};

const RECEIVE_FIRST_BATCH = 'theatres/RECEIVE_FIRST_BATCH';
const RECEIVE_MORE = 'theatres/RECEIVE_MORE';
const LOADING_STATUS = 'theatres/LOADING_STATUS';
const SET_SEARCHED_THEATRE_NAME = 'theatres/SET_SEARCHED_THEATRE_NAME';
const SET_BUSY_LOADING_DATA_FROM_SERVER_STATUS =
  'theatres/SET_BUSY_LOADING_DATA_FROM_SERVER_STATUS';
const RESET = 'theatres/RESET';

export function receiveFirstBatchOfTheatres(payload, meta) {
  return { type: RECEIVE_FIRST_BATCH, payload: payload, meta: meta };
}

export function receiveMoreTheatres(payload, meta) {
  return { type: RECEIVE_MORE, payload: payload, meta: meta };
}

export function setTheatresLoadingStatus(status) {
  return { type: LOADING_STATUS, payload: status };
}

export function setSearchedTheatreName(name) {
  return { type: SET_SEARCHED_THEATRE_NAME, payload: name };
}

function setBusyLoadingDataFromServerStatus(status) {
  return { type: SET_BUSY_LOADING_DATA_FROM_SERVER_STATUS, payload: status };
}

export function resetTheatres() {
  return { type: RESET };
}

export function loadMoreTheatres() {
  return (dispatch, getState) => {
    let { searchedTheatreName, offset, ps, hasMoreTheatres } =
      getState().theatres;

    if (!hasMoreTheatres) return;

    dispatch(loadTheatres(searchedTheatreName, offset, ps));
  };
}

export function loadFirstBatchOfTheatres(theatreName) {
  return (dispatch, getState) => {
    let { offset, ps } = initialState;
    let previousQuery = getState().theatres.searchedTheatreName;

    theatreName = _.trim(theatreName);

    if (theatreName != previousQuery) {
      dispatch(resetTheatres());
      dispatch(setSearchedTheatreName(theatreName));
      dispatch(loadTheatres(theatreName, offset, ps));
    }
  };
}

function loadTheatres(theatreName, offset, ps) {
  return (dispatch, getState) => {
    let { busyLoadingDataFromServer } = getState().theatres;

    if (busyLoadingDataFromServer) {
      return;
    }

    if (offset === 0) {
      dispatch(setTheatresLoadingStatus(true));
    }

    dispatch(setBusyLoadingDataFromServerStatus(true));

    return monarch
      .get(`/v1/theatres/search?offset=${offset}&ps=${ps}&q=${theatreName}`)
      .then((res) => {
        dispatch(setBusyLoadingDataFromServerStatus(false));

        if (offset === 0) {
          dispatch(setTheatresLoadingStatus(false));
        }

        let meta = {
          query: theatreName,
          hasMoreTheatres: res.data.hasMoreTheatres,
        };

        if (offset === 0) {
          dispatch(receiveFirstBatchOfTheatres(res.data, meta));
        } else {
          dispatch(receiveMoreTheatres(res.data, meta));
        }
      })
      .catch((error) => {
        if (offset === 0) {
          dispatch(setTheatresLoadingStatus(false));
          dispatch(handleAppError(error, I18n.t('errorInTheatresSearch')));
        }
      });
  };
}

export default function reducer(state = initialState, action) {
  let { type, payload, meta } = action;

  switch (type) {
    case RECEIVE_FIRST_BATCH:
      if (meta.query !== state.searchedTheatreName) {
        return update(state, {
          isLoading: { $set: true },
        });
      }

      return update(state, {
        theatres: { $set: payload.theatres },
        hasMoreTheatres: { $set: meta.hasMoreTheatres },
        offset: { $set: state.ps },
      });

    case RECEIVE_MORE: {
      if (meta.query !== state.searchedTheatreName) {
        return state;
      }

      let newTheatres = update(state.theatres, { $push: payload.theatres });
      let uniqueTheaters = _.uniqBy(newTheatres, 'id');

      return update(state, {
        theatres: { $set: uniqueTheaters },
        hasMoreTheatres: { $set: meta.hasMoreTheatres },
        offset: { $set: state.offset + state.ps },
      });
    }

    case LOADING_STATUS:
      return update(state, { isLoading: { $set: payload } });

    case SET_SEARCHED_THEATRE_NAME:
      return update(state, {
        searchedTheatreName: { $set: payload },
        theatres: { $set: [] },
      });

    case SET_BUSY_LOADING_DATA_FROM_SERVER_STATUS:
      return update(state, { busyLoadingDataFromServer: { $set: payload } });

    case RESET:
      return initialState;

    default:
      return state;
  }
}
